import React, { useState } from 'react';
export function OfferSection() {
  const [selected, setSelected] = useState<'basic' | 'premium' | 'ultimate'>('premium');
  return <section id="oferta" className="py-6 md:py-9 px-5 bg-gradient-to-b from-dark-bg to-card-bg text-center" data-id="element-116">
      <div className="max-w-[900px] mx-auto" data-id="element-117">
        <span className="inline-block font-heading font-bold text-[0.75rem] tracking-[3px] uppercase text-magenta-bright mb-2" data-id="element-118">
          La inversión
        </span>

        <h2 className="font-heading font-black mb-3 text-[23px]" data-id="element-119">
          Todo lo que necesitas para
          <br data-id="element-120" />
          <span className="text-gradient-magenta" data-id="element-121">
            interrumpir el ciclo — hoy
          </span>
        </h2>

        <div className="max-w-[550px] mx-auto mt-3 space-y-2.5" data-id="element-122">
          {/* Card 1: Colección Completa */}
          <button type="button" onClick={() => setSelected('basic')} className={`w-full text-left rounded-2xl p-3.5 md:p-4 border-2 transition-all duration-300 cursor-pointer bg-card-bg relative ${selected === 'basic' ? 'border-magenta-bright shadow-[0_0_30px_rgba(255,45,155,0.2)]' : 'border-white/15 hover:border-white/30'}`} data-id="element-123">
            <div className="flex items-start gap-3" data-id="element-124">
              {/* Radio */}
              <div className="mt-1 shrink-0" data-id="element-125">
                <div className={`w-5 h-5 rounded-full border-2 flex items-center justify-center transition-colors ${selected === 'basic' ? 'border-magenta-bright' : 'border-white/30'}`} data-id="element-126">
                  {selected === 'basic' && <div className="w-2.5 h-2.5 rounded-full bg-magenta-bright" data-id="element-127" />}
                </div>
              </div>

              <div className="flex-1 min-w-0" data-id="element-128">
                <h3 className="font-heading font-black text-[1rem] md:text-[1.15rem] text-white leading-tight" data-id="element-129">
                  ⚡ MATERIAL COMPLETO
                </h3>
                <p className="text-white/60 text-[0.8rem] mt-0.5" data-id="element-130">
                  4 volúmenes + 3 Bonos de regalo
                </p>
              </div>

              <div className="text-right shrink-0" data-id="element-131">
                <p className="text-white/40 text-[0.8rem] line-through leading-none" data-id="element-132">
                  $39.990
                </p>
                <p className="font-heading font-black text-[1.5rem] md:text-[1.85rem] text-magenta-bright leading-none mt-0.5" data-id="element-133">
                  $19.999
                </p>
              </div>
            </div>
          </button>

          {/* Card 2: Colección + Guía (Highlighted) */}
          <button type="button" onClick={() => setSelected('premium')} className={`w-full text-left rounded-2xl p-3.5 md:p-4 border-2 transition-all duration-300 cursor-pointer bg-card-bg relative ${selected === 'premium' ? 'border-magenta-bright shadow-[0_0_30px_rgba(255,45,155,0.2)]' : 'border-white/15 hover:border-white/30'}`} data-id="element-134">
            <div className="flex items-start gap-3" data-id="element-135">
              {/* Radio */}
              <div className="mt-1 shrink-0" data-id="element-136">
                <div className={`w-5 h-5 rounded-full border-2 flex items-center justify-center transition-colors ${selected === 'premium' ? 'border-magenta-bright' : 'border-white/30'}`} data-id="element-137">
                  {selected === 'premium' && <div className="w-2.5 h-2.5 rounded-full bg-magenta-bright" data-id="element-138" />}
                </div>
              </div>

              {/* Content area */}
              <div className="flex-1 min-w-0" data-id="element-139">
                {/* Image + Title row */}
                <div className="flex items-center gap-2.5 mb-1.5" data-id="element-140">
                  <div className="shrink-0" data-id="element-141">
                    <img src="https://cdn.magicpatterns.com/uploads/3FYBiYBmRMkgRmmVjg4YAT/ChatGPT_Image_11_mar_2026,_14_30_25.png" alt="Kit de Emergencia" className="w-[56px] md:w-[68px] h-auto rounded-md drop-shadow-[0_4px_12px_rgba(194,0,111,0.4)]" style={{
                    mixBlendMode: 'lighten'
                  }} data-id="element-142" />
                  </div>
                  <h3 className="font-heading font-black text-[0.95rem] md:text-[1.15rem] text-white leading-tight" data-id="element-143">
                    MATERIAL COMPLETO + KIT DE EMERGENCIA
                  </h3>
                </div>

                {/* Badges */}
                <div className="flex flex-wrap gap-2 mb-1.5" data-id="element-144">
                  <span className="inline-flex items-center gap-1 bg-gradient-to-r from-gold to-gold-warm text-dark-bg font-heading font-bold text-[0.65rem] tracking-[1px] uppercase py-0.5 px-2.5 rounded-md" data-id="element-145">
                    ⭐ MÁS ELEGIDO
                  </span>
                </div>

                {/* Description */}
                <p className="text-white/60 text-[0.8rem] mb-2 leading-snug" data-id="element-146">
                  Como desactivar el impulso adictivo antes de que tome el
                  control.
                </p>

                {/* Price row */}
                <div className="flex items-baseline gap-3" data-id="element-147">
                  <p className="text-white/40 text-[0.8rem] line-through" data-id="element-148">
                    $49.990
                  </p>
                  <p className="font-heading font-black text-[1.5rem] md:text-[1.85rem] text-magenta-bright leading-none" data-id="element-149">
                    $29.999
                  </p>
                </div>
              </div>
            </div>
          </button>

          {/* Card 3: Colección + Kit + El Casi Gano */}
          <button type="button" onClick={() => setSelected('ultimate')} className={`w-full text-left rounded-2xl p-3.5 md:p-4 border-2 transition-all duration-300 cursor-pointer bg-card-bg relative ${selected === 'ultimate' ? 'border-magenta-bright shadow-[0_0_30px_rgba(255,45,155,0.2)]' : 'border-white/15 hover:border-white/30'}`} data-id="element-150">
            <div className="flex items-start gap-3" data-id="element-151">
              {/* Radio */}
              <div className="mt-1 shrink-0" data-id="element-152">
                <div className={`w-5 h-5 rounded-full border-2 flex items-center justify-center transition-colors ${selected === 'ultimate' ? 'border-magenta-bright' : 'border-white/30'}`} data-id="element-153">
                  {selected === 'ultimate' && <div className="w-2.5 h-2.5 rounded-full bg-magenta-bright" data-id="element-154" />}
                </div>
              </div>

              {/* Content area */}
              <div className="flex-1 min-w-0" data-id="element-155">
                {/* Image + Title row */}
                <div className="flex items-center gap-2.5 mb-1.5" data-id="element-156">
                  <div className="shrink-0" data-id="element-157">
                    <img src="https://cdn.magicpatterns.com/uploads/opfGMvRq2e1h7Hh1cKcuxF/WhatsApp_Image_2026-03-13_at_7.13.29_PM.jpg" alt="El Casi Gano — Ludopatía" className="w-[56px] md:w-[68px] h-auto rounded-md drop-shadow-[0_4px_12px_rgba(194,0,111,0.4)]" style={{
                    mixBlendMode: 'lighten'
                  }} data-id="element-158" />
                  </div>
                  <h3 className="font-heading font-black text-[0.95rem] md:text-[1.15rem] text-white leading-tight" data-id="element-159">
                    MATERIAL COMPLETO + KIT DE EMERGENCIA + EL CASI GANO
                    <span className="block text-[0.75rem] md:text-[0.85rem] text-magenta-bright font-bold mt-0.5" data-id="element-160">
                      (Ludopatía)
                    </span>
                  </h3>
                </div>

                {/* Badges */}
                <div className="flex flex-wrap gap-2 mb-1.5" data-id="element-161">
                  <span className="inline-flex items-center gap-1 bg-gradient-to-r from-gold to-gold-warm text-dark-bg font-heading font-bold text-[0.65rem] tracking-[1px] uppercase py-0.5 px-2.5 rounded-md" data-id="element-162">
                    🔥 PACK DEFINITIVO
                  </span>
                </div>

                {/* Description */}
                <p className="text-white/60 text-[0.8rem] mb-2 leading-snug" data-id="element-163">
                  Todo el sistema completo + la guía para vencer la ludopatía de
                  raíz.
                </p>

                {/* Price row */}
                <div className="flex items-baseline gap-3" data-id="element-164">
                  <p className="text-white/40 text-[0.8rem] line-through" data-id="element-165">
                    $69.990
                  </p>
                  <p className="font-heading font-black text-[1.5rem] md:text-[1.85rem] text-magenta-bright leading-none" data-id="element-166">
                    $39.999
                  </p>
                </div>
              </div>
            </div>
          </button>
        </div>

        {/* CTA Button */}
        <div className="max-w-[550px] mx-auto mt-6" data-id="element-167">
          <a href={selected === 'basic' ? 'https://pagos.indigo33.shop/cart/63651107668337:1' : selected === 'premium' ? 'https://pagos.indigo33.shop/cart/63651112288625:1' : 'https://pagos.indigo33.shop/cart/63651115762033:1'} className="block text-center w-full bg-gradient-to-br from-magenta to-magenta-bright text-white font-heading font-black text-[1.15rem] md:text-[1.3rem] py-5 px-5 rounded-2xl uppercase tracking-[1px] shadow-[0_8px_30px_rgba(194,0,111,0.5),0_0_60px_rgba(194,0,111,0.2)] transition-all duration-300 hover:-translate-y-[3px] hover:shadow-[0_12px_40px_rgba(194,0,111,0.7),0_0_80px_rgba(194,0,111,0.3)]" data-id="element-168">
            {'S\xCD, QUIERO EL MATERIAL COMPLETO'}
          </a>

          <div className="flex justify-center mt-4" data-id="element-169">
            <img src="https://cdn.magicpatterns.com/uploads/iAwRVcP6c5wjxBYiWFb4cu/descarga.png" alt="Métodos de pago: Visa, Mastercard, Mercado Pago" className="h-[32px] md:h-[38px] w-auto object-contain opacity-70" data-id="element-170" />
          </div>

          <p className="text-white/50 text-[0.95rem] italic mt-3 leading-relaxed" data-id="element-171">
            La opción más elegida por quienes quieren
            <br className="hidden sm:block" data-id="element-172" /> recuperarse de verdad
          </p>
        </div>

        {/* Trust Badges */}
        <div className="max-w-[550px] mx-auto mt-5 flex flex-wrap items-center justify-center gap-x-6 gap-y-3 text-[0.85rem] text-white/60" data-id="element-173">
          <span className="flex items-center gap-2" data-id="element-174">
            <span className="text-magenta-bright" data-id="element-175">🔒</span> Pago seguro
          </span>
          <span className="flex items-center gap-2" data-id="element-176">
            <span className="text-magenta-bright" data-id="element-177">⏱️</span> Acceso inmediato
          </span>
        </div>
        <div className="max-w-[550px] mx-auto mt-2 flex flex-wrap items-center justify-center gap-x-4 gap-y-2 text-[0.8rem] text-white/40" data-id="element-178">
          <span className="flex items-center gap-1.5" data-id="element-179">🛡️ Pago protegido</span>
          <span data-id="element-180">•</span>
          <span className="flex items-center gap-1.5" data-id="element-181">📦 Sin suscripción</span>
        </div>
      </div>
    </section>;
}